import axiosServices from 'utils/axios';

export interface AskHoaResponse {
  question: string;
  answer: string;
  sessionId: string;
}

export type AskHoaSummaryQueueType =
  | 'open_requests'
  | 'overdue_requests'
  | 'open_violations'
  | 'overdue_violations';

export interface AskHoaSummaryRequest {
  queueType: AskHoaSummaryQueueType;
  communityId: string;
  ticketIds?: string[];
  maxItems?: number;
  focus?: string;
  sessionId?: string;
}

export interface AskHoaSummaryResponse {
  schemaVersion: 'v1';
  queueType: AskHoaSummaryQueueType;
  sessionId: string;
  generatedAt: string;
  metadata: {
    itemCountTotal: number;
    itemCountIncluded: number;
    model: string;
  };
  snapshot: {
    headline: string;
    totalsByPriority: Record<string, number>;
    totalsByCategory: Record<string, number>;
  };
  urgentRisks: Array<{
    title: string;
    severity: 'high' | 'critical';
    reason: string;
    ticketIds: string[];
  }>;
  teamSignals: Array<{
    team: string;
    signal: string;
    impactedCount: number;
  }>;
  recommendedActions: Array<{
    action: string;
    rationale: string;
    priority: 'now' | 'today' | 'this_week';
  }>;
  narrativeSummary: string;
  handoffPrompt: string;
}

export async function askHoa(params: {
  question: string;
  communityId: string;
  sessionId?: string;
  topK?: number;
}): Promise<AskHoaResponse> {
  const { data } = await axiosServices.post<AskHoaResponse>('/api/ask-hoa', params);
  return data;
}

export async function askHoaSummary(params: AskHoaSummaryRequest): Promise<AskHoaSummaryResponse> {
  const { data } = await axiosServices.post<AskHoaSummaryResponse>('/api/ask-hoa/summary', params);
  return data;
}
